import { Set } from '~commonInfra/utils/Set';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { Messages } from '../../../../codegen/Localize';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '../../../../commonInfra/L10n/L10n';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { openDeleteGroupConfirmationDialog } from '../../components/DeleteGroupConfirmationDialog';
import { Groups } from '../../Groups';
import { IGroupBasicInfo, IGroupInfo } from '../../models/IGroupInfo';
import { DeleteGroupsNotificationAction } from '../notifications/DeleteGroupsNotificationAction';

function showDeleteGroupDialog(
  groups: Set<IGroupInfo>): Promise<any> {

  let dialogBody: string;

  if (getSessionManagementServiceInstance().isGroupSetsEnabledForSite())
  {
    if (groups.size() === 1) {
      const group = groups.first();
      dialogBody = Messages.confirmDeleteGroupWithGroupSets({ GROUP_NAME: L10n.elideIfLong(group.name) });
    } else {
      dialogBody = Messages.confirmDeleteGroupsWithGroupSets({ GROUP_COUNT_LOC: L10n.localizedCount(groups.size()) });
    }
  } else {
    if (groups.size() === 1) {
      const group = groups.first();
      dialogBody = Messages.confirmDeleteGroup({ GROUP_NAME: L10n.elideIfLong(group.name) });
    } else {
      dialogBody = Messages.confirmDeleteGroups({ GROUP_COUNT_LOC: L10n.localizedCount(groups.size()) });
    }
  }

  let containsExternalUserGroup = containsExternalUserEnabledGroup(groups);

  const dialogInstance = openDeleteGroupConfirmationDialog<string[], IResult>({
    title: groups.size() === 1 ? Messages.deleteGroupMessage(): Messages.deleteMultipleGroupsMessage(),
    message: dialogBody,
    actionName: Messages.confirmDeleteButton({ ITEM_COUNT: groups.size() , ITEM_COUNT_LOC: L10n.localizedCount(groups.size()) }),
    isActionDelete: true,
    action: Groups.deleteGroups.bind(Groups),
    paramsForAction: groups.keys(),
    dialogWidth: containsExternalUserGroup? TabDialogWidth.width500px: TabDialogWidth.width375px,
  }, containsExternalUserGroup);

  dialogInstance.result.then((result: IResult) => {
    DeleteGroupsNotificationAction.notify(result, groups);
  });

  return Promise.resolve(dialogInstance.result);
}

function deleteGroup(group: IGroupBasicInfo): Promise<any> {
  const groups = new Set<IGroupBasicInfo>((group: IGroupInfo) => group.id);
  groups.add(group);
  return DeleteGroupAction.showDeleteGroupDialog(groups);
}

export const DeleteGroupAction = {
  showDeleteGroupDialog,
  deleteGroup
};

function containsExternalUserEnabledGroup(groups: Set<IGroupInfo>): boolean {
  for (let i = 0; i < groups.size(); i++) {
    if (groups.getByIndex(i).externalUserEnabled) {
      return true;
    }
  }
  return false;
}

export type DeleteGroupAction = typeof DeleteGroupAction;
